scroll_to = function(anchor) {
  // スクロールの速度
  var speed = 400; // ミリ秒
  // 移動先を取得
  var target = jQuery('#' + anchor);

  // 移動先を数値で取得
  var position = target.offset().top;
  // スムーススクロール
  jQuery('body,html').animate({scrollTop:0}, speed, 'swing');
}

$(document).on('click','a[href^="#"]', function(e){
  var header = 115; // header分
  var speed = 400;
  var href= $(this).attr("href");
  var target = $(href == "#" || href == "" ? 'html' : href);
  var position = target.offset().top - header;
  $("html, body").animate({scrollTop:position}, speed, "swing");
  return false;
});
